import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';

const AgeGate = ({ onVerify }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem('mb_age_verified');
    if (!verified) setVisible(true);
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem('mb_age_verified', 'true');
    setVisible(false);
    onVerify(true);
  };

  const handleDecline = () => {
    window.location.href = 'https://google.com';
  };

  return (
    <AnimatePresence>
      {visible && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: 'fixed', inset: 0, zIndex: 9998,
              backdropFilter: 'blur(20px) saturate(0.6)',
              background: 'rgba(10,20,14,0.72)',
            }}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.94, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 12 }}
            transition={{ type: 'spring', damping: 28, stiffness: 220 }}
            style={{
              position: 'fixed', inset: 0, zIndex: 9999,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: '16px',
              overflowY: 'auto',
            }}
          >
            <div style={{
              background: 'var(--white)',
              borderRadius: '20px',
              padding: 'clamp(24px, 5vw, 40px) clamp(20px, 5vw, 40px) clamp(20px, 4vw, 32px)',
              maxWidth: '400px',
              width: '100%',
              textAlign: 'center',
              boxShadow: '0 32px 80px rgba(0,0,0,0.32)',
              border: '1px solid var(--mist)',
              position: 'relative',
              overflow: 'hidden',
              margin: 'auto',
            }}>
              {/* Top accent line */}
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0,
                height: '3px',
                background: 'linear-gradient(90deg, var(--forest), var(--gold))',
              }} />

              {/* Icon */}
              <div style={{
                width: '52px', height: '52px',
                background: 'var(--forest)',
                borderRadius: '14px',
                margin: '0 auto 20px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <ShieldCheck size={24} color="white" />
              </div>

              <h2 style={{
                fontFamily: 'Syne', fontWeight: 700,
                fontSize: 'clamp(1.3rem, 5vw, 1.6rem)',
                color: 'var(--forest)',
                marginBottom: '8px', letterSpacing: '-0.01em',
              }}>
                Age Verification
              </h2>
              <p style={{
                fontFamily: 'DM Sans',
                color: 'var(--mid)', fontSize: 'clamp(0.82rem, 3vw, 0.92rem)',
                marginBottom: '24px', lineHeight: '1.65',
              }}>
                Mind Blown products are intended for adults 21 and older. Please confirm your age to continue.
              </p>

              <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
                <button
                  onClick={handleAccept}
                  style={{
                    flex: 1,
                    background: 'var(--forest)',
                    color: 'var(--white)',
                    border: 'none',
                    borderRadius: '10px',
                    padding: 'clamp(12px, 3vw, 14px) 16px',
                    fontFamily: 'Syne',
                    fontWeight: 700,
                    fontSize: 'clamp(0.78rem, 3vw, 0.85rem)',
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    minHeight: '48px',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--accent-green)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'var(--forest)'}
                >
                  I am 21+
                </button>
                <button
                  onClick={handleDecline}
                  style={{
                    flex: 1,
                    background: 'transparent',
                    color: 'var(--mid)',
                    border: '1.5px solid var(--mist)',
                    borderRadius: '10px',
                    padding: 'clamp(12px, 3vw, 14px) 16px',
                    fontFamily: 'Syne',
                    fontWeight: 600,
                    fontSize: 'clamp(0.78rem, 3vw, 0.85rem)',
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    minHeight: '48px',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--charcoal)'; e.currentTarget.style.color = 'var(--charcoal)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--mist)'; e.currentTarget.style.color = 'var(--mid)'; }}
                >
                  Under 21
                </button>
              </div>

              <p style={{
                fontSize: 'clamp(0.64rem, 2.5vw, 0.7rem)',
                color: 'var(--light-text)', lineHeight: '1.5',
              }}>
                Secure age verification by BlueCheck. Your information is never stored or shared.
              </p>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AgeGate;
